import React from "react";

const DobIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={53}
    viewBox="0 0 50 53"
    fill="none"
    {...props}
  >
    <path
      d="M4.531 25.105v20.438c0 1.355.533 2.655 1.48 3.613a5.024 5.024 0 003.573 1.497H39.9c1.34 0 2.625-.539 3.572-1.497a5.138 5.138 0 001.48-3.613V25.105"
      stroke="#8065C9"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.736 11.055a8.993 8.993 0 00-2.59-6.323 8.792 8.792 0 00-6.252-2.619 6.28 6.28 0 00-4.466 1.87A6.423 6.423 0 009.578 8.5c0 1.694.665 3.318 1.85 4.516a6.28 6.28 0 004.466 1.87h8.842m0-3.831v3.832m0-3.832c0-2.372.932-4.646 2.59-6.323a8.793 8.793 0 016.252-2.619 6.28 6.28 0 014.466 1.87 6.449 6.449 0 011.37 6.96 6.394 6.394 0 01-1.37 2.073 6.312 6.312 0 01-2.049 1.385 6.255 6.255 0 01-2.417.486h-8.842"
      stroke="#8065C9"
      strokeWidth={3.5}
      strokeLinejoin="round"
    />
    <path
      d="M24.737 25.102v25.547M2 14.883h45.474v10.219H2v-10.22z"
      stroke="#8065C9"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DobIcon;
